import { render, staticRenderFns } from "./BatchUserUploadToolDeletePoints.vue?vue&type=template&id=74479724&scoped=true&"
import script from "./BatchUserUploadToolDeletePoints.vue?vue&type=script&lang=js&"
export * from "./BatchUserUploadToolDeletePoints.vue?vue&type=script&lang=js&"
import style0 from "./BatchUserUploadToolDeletePoints.vue?vue&type=style&index=0&id=74479724&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74479724",
  null
  
)

export default component.exports